import React from "react";
import { education } from "../lib/data";
import type { Certification } from "../lib/types";

function EducationSection() {
  return (
    <div className="opacity-0-start animate-fade-in-d1 flex flex-col gap-6">
      <h2 className="text-xl font-bold">Education</h2>

      <div className="bg-bg-surface border border-border rounded-lg p-7 flex flex-col gap-5">
        {/* Degree */}
        <div>
          <h3 className="text-base font-semibold text-content">
            {education.degree}
          </h3>
          <div className="flex items-center gap-2 mt-1">
            <span className="text-sm text-brand">{education.school}</span>
            <span className="text-xs text-content-muted font-mono">
              {education.period}
            </span>
          </div>
        </div>

        {/* Coursework */}
        <div>
          <div className="text-2xs text-content-muted font-mono uppercase tracking-widest mb-2.5">
            Relevant Coursework
          </div>
          <div className="flex flex-wrap gap-2">
            {education.coursework.map((c: string) => (
              <span
                key={c}
                className="px-3 py-1 rounded-md text-xs bg-bg-raised text-content-secondary border border-border-subtle font-mono"
              >
                {c}
              </span>
            ))}
          </div>
        </div>

        {/* Certifications */}
        <div>
          <div className="text-2xs text-content-muted font-mono uppercase tracking-widest mb-2.5">
            Certifications
          </div>
          <div className="flex flex-col gap-2">
            {education.certifications.map((cert: Certification) => {
              if (cert.href) {
                return (
                  <a
                    key={cert.name}
                    href={cert.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 text-sm text-accent no-underline hover:underline"
                  >
                    <span>✓</span> {cert.name}
                  </a>
                );
              }
              return (
                <span
                  key={cert.name}
                  className="flex items-center gap-2 text-sm text-content-secondary"
                >
                  <span className="text-accent">✓</span> {cert.name}
                </span>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default EducationSection;